import './style.scss';

import { AppMenu } from '@components/AppMenu/AppMenu';
import { TabletHeader } from '@components/TabletHeader/TabletHeader';
import { Avatar, ConfigProvider, Layout } from 'antd';
import { Outlet } from 'react-router';

import { useGetMeQuery, useLogoutMutation } from '@/api/auth/api';
import { globalTheme } from '@/styles/theme';
import { DeviceType } from '@/utils/detectedDevice';

const { Content, Sider } = Layout;

interface AppProps {
  deviceType: DeviceType;
}

export const App = ({ deviceType }: AppProps) => {
  const { data: user } = useGetMeQuery();
  const [logout] = useLogoutMutation();

  const getInitials = (user: any): string => {
    const { firstName, lastName } = user;
    return [firstName, lastName]
      .filter(Boolean)
      .map((name) => name?.[0]?.toUpperCase())
      .join('');
  };

  return (
    <ConfigProvider theme={globalTheme}>
      <Layout className={'layout'}>
        {deviceType === 'tablet' ? (
          <TabletHeader user={user} />
        ) : (
          <Sider
            style={{ height: '100vh' }}
            theme={'light'}
            className={'sider'}
            width={318}>
            <div className={'menu-wrapper'}>
              <div>
                <div className={'menu-text'}>
                  Автоматизированная информационная система “Ветпротокол”
                </div>
                <div className={'avatar-wrapper'}>
                  <Avatar size={66}>{user && getInitials(user)}</Avatar>
                </div>

                <AppMenu />
              </div>
              <div className={'logout'}>
                <a
                  onClick={async () => {
                    await logout();
                  }}>
                  Выйти
                </a>
              </div>
            </div>
          </Sider>
        )}
        <Layout>
          <Content
            className={`content ${deviceType === 'tablet' ? 'content-tablet' : ''}`}>
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};
